import Vue from "vue";
import Router from "vue-router";
import store from "./store/store";

import Errors from "./views/SAMPLE/Errors.vue";

import Apps from "./views/Apps.vue";
import Dashboard from "./views/Dashboard.vue";
import Developer from "./views/Developer.vue";
import Orders from "./views/Orders/index";
import Profile from "./views/Profile.vue";
import Products from "./views/Products/index";

import OrderStatuses from "./views/OrderStatuses";
import ProductCategories from "./views/ProductCategories";
import ProductCollections from "./views/ProductCollections";
import Storefronts from "./views/Settings/Storefronts";
import Team from "./views/Team/index";
import Signin from "./views/Auth/Signin.vue";
import ResetPassword from "./views/Auth/ResetPassword.vue";
import ForgotPassword from "./views/Auth/ForgotPassword.vue";
import Logout from "./views/Auth/Logout.vue";
import Settings from "./views/Settings/Dashboard.vue";
import Documents from "./views/Documents";
import Merchants from './views/Merchants';

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      redirect: "/dashboard"
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true,
        group: "dashboard"
      }
    },
    {
      path: "/apps",
      name: "apps",
      component: Apps,
      meta: {
        requiresAuth: true,
        group: "apps"
      }
    },
    {
      path: "/orders",
      name: "orders",
      component: Orders.Main,
      meta: {
        requiresAuth: true,
        group: "orders"
      }
    },
    {
      path: "/orders/statuses",
      name: "order_statuses",
      component: OrderStatuses.Main,
      meta: {
        requiresAuth: true,
        group: "orders"
      }
    },
    {
      path: "/merchants",
      name: "merchants",
      component: Merchants.Main,
      meta: {
        requiresAuth: true,
        group: "merchants"
      }
    },
    {
      path: "/products",
      name: "products",
      component: Products.Main,
      meta: {
        requiresAuth: true,
        group: "products"
      }
    },
    // {
    //   path: "/products/add",
    //   name: "products_add",
    //   component: Products.Add,
    //   meta: {
    //     requiresAuth: true,
    //     group: "products"
    //   }
    // },
    {
      path: "/products/edit/:key",
      name: "products__edit",
      component: Products.EditPage,
      meta: {
        requiresAuth: true,
        group: "products"
      }
    },
    {
      path: "/products/edit/:key/email",
      name: "products__edit__email",
      component: Products.EditEmail,
      meta: {
        requiresAuth: true,
        group: "products"
      }
    },
    {
      path: "/products/edit/:key/customizations",
      name: "products__edit__customizations",
      component: Products.EditCustomizations,
      meta: {
        requiresAuth: true,
        group: "products"
      }
    },
    {
      path: "/products/edit/:key/post-purchase",
      name: "products__edit__post_purchase_content",
      component: Products.EditPostPurchaseContent,
      meta: {
        requiresAuth: true,
        group: "products"
      }
    },
    {
      path: "/products/categories",
      name: "products_categories",
      component: ProductCategories.Main,
      meta: {
        requiresAuth: true,
        group: "products"
      }
    },
    {
      path: "/products/collections",
      name: "products_collections",
      component: ProductCollections.Main,
      meta: {
        requiresAuth: true,
        group: "products"
      }
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: {
        requiresAuth: true,
        group: "profile"
      }
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings,
      meta: {
        requiresAuth: true,
        group: "settings"
      }
    },
    {
      path: "/documents",
      name: "documents",
      component: Documents.Dashboard,
      meta: {
        requiresAuth: true,
        group: "documents"
      }
    },
    {
      path: "/team",
      name: "team",
      component: Team.Dashboard,
      meta: {
        requiresAuth: true,
        group: "team"
      }
    },
    {
      path: "/team/add",
      name: "team_add",
      component: Team.Add,
      meta: {
        requiresAuth: true,
        group: "team"
      }
    },
    {
      path: "/team/edit",
      name: "team_edit",
      component: Team.Edit,
      meta: {
        requiresAuth: true,
        group: "team"
      }
    },
    {
      path: "/team/edit/:key",
      name: "team_edit_key",
      component: Team.Edit,
      meta: {
        requiresAuth: true,
        group: "team"
      }
    },
    {
      path: "/dev",
      name: "dev",
      component: Developer,
      meta: {
        requiresAuth: true,
        group: "dev"
      }
    },
    {
      path: "/auth",
      redirect: "/auth/signin"
    },
    {
      path: "/auth/signin",
      name: "signin",
      component: Signin,
      meta: {
        layout: "simple"
      }
    },
    {
      path: "/auth/forgot",
      name: "forgot",
      component: ForgotPassword,
      meta: {
        layout: "simple"
      }
    },
    {
      path: "/auth/reset",
      name: "reset",
      component: ResetPassword,
      meta: {
        layout: "simple"
      }
    },
    {
      path: "/auth/logout",
      name: "logout",
      component: Logout,
      meta: {
        layout: "simple"
      }
    },

    {
      path: "/blog-overview",
      name: "blog-overview",
      component: () =>
        import(
          /* webpackChunkName: "PersonalBlog" */ "./views/SAMPLE/PersonalBlog.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/user-profile-lite",
      name: "user-profile-lite",
      component: () =>
        import(
          /* webpackChunkName: "UserProfileLite" */ "./views/SAMPLE/UserProfileLite.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/add-new-post",
      name: "add-new-post",
      component: () =>
        import(
          /* webpackChunkName: "AddNewPost" */ "./views/SAMPLE/AddNewPost.vue"
        ),

      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/errors",
      name: "errors",
      component: Errors,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/components-overview",
      name: "components-overview",
      component: () =>
        import(
          /* webpackChunkName: "ComponentsOverview" */ "./views/SAMPLE/ComponentsOverview.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/tables",
      name: "tables",
      component: () =>
        import(/* webpackChunkName: "Tables" */ "./views/SAMPLE/Tables.vue"),
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/blog-posts",
      name: "blog-posts",
      component: () =>
        import(
          /* webpackChunkName: "BlogPosts" */ "./views/SAMPLE/BlogPosts.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "*",
      redirect: "/errors"
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters["auth/authenticated"]) {
      next();
      return;
    }
    next(`/auth/signin?next=${to.path}`);
  } else {
    next();
  }
});

export default router;
